import { DefaultInfo } from "features/shared/types/info";
import { Tag } from "features/shared/types/tag";

// note the naming convention is a bit weird
// text-based content are all labeled as type Article
export enum ArticleType {
    News = "News",
    Article = "Article",
    Supplier = "Supplier",
}
export interface Article {
    id: string;
    type: ArticleType;
    tags: Tag["key"][];
    properties: DefaultInfo;
}
